import { render } from "./AddBaseRefPopup.vue?vue&type=template&id=8be1254e&scoped=true"
import script from "./AddBaseRefPopup.vue?vue&type=script&lang=js"
export * from "./AddBaseRefPopup.vue?vue&type=script&lang=js"

import "./AddBaseRefPopup.vue?vue&type=style&index=0&id=8be1254e&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8be1254e"]])

export default __exports__